import React, { useState, useEffect } from 'react';
import { preferencesPhrasesStorage } from '../../services/preferencesPhrasesStorage';
import { StarIcon } from '../../appearence/icons/star_icon';
import {IconWrapper} from "../../appearence/icons/icon_wrapper";

const PhrasesListItemWelcomeIcon = ({ preferencePhraseId }) => {
    const [isVisible, setIsVisible] = useState(false);

    const changeIconVisibility = () => {
        setIsVisible(preferencesPhrasesStorage.getById(preferencePhraseId)?.isWelcome);
    };

    const unCheckPhraseFromWelcomeList = () => {
        preferencesPhrasesStorage.updatePreferenceIsWelcome(false, preferencePhraseId);
    };

    useEffect(() => {
        preferencesPhrasesStorage.registerFiltersChangingObserver(changeIconVisibility);
        changeIconVisibility();
        return () => {
            preferencesPhrasesStorage.unRegisterFiltersChangingObserver(changeIconVisibility);
        };
    }, []);

    return (
        isVisible ? <IconWrapper handleClick={unCheckPhraseFromWelcomeList}><StarIcon/></IconWrapper> : null
    );
};

export default PhrasesListItemWelcomeIcon;
